import React, { useEffect, useState } from "react";
import { Dropdown, Panel } from "./Panel";
import { useDispatch, useSelector } from "react-redux";
import { AppState } from "../../../../../stateManager/store";
import { updateElement } from "../../../../../stateManager/store/formCreation_v2/actions";
import { ListValidationValue } from "./ListValidation";
import { getComponents } from "../helpers";

const validationTypeList = [
  { label: 'minlength', value: 'minlength', validType: "Number" },
  { label: 'maxlength', value: 'maxlength', validType: "Number" },
  { label: 'pattern', value: 'pattern', validType: "All" },
]

const validationPropertyList = [
  "min",
  "max",
  "minlength",
  "maxlength",
  "pattern",
];
const initialValues={
  minlength: "",
  maxlength: "",
  min: "",
  max: "",
  pattern: ""
}
export const Validation = (props:any) => {
  const [labelOptionsList,setLabelOptionsList] = useState(
    validationTypeList || []
  );
  const [selectedValue, setSelectedValue] = useState<string>("");
  const [values, setValues] = useState<any>(initialValues);
  const dispatch = useDispatch();
  const { selectedElementId } = useSelector((state: AppState) => state.formJson)
  const { components } = getComponents()
  const component = components[selectedElementId]
  const selectedList = Object.keys(component?.properties?.validation ?? {});
  const ExcludedComponentTypes = ["dateinput", "datepicker"];
  const handleChange = (e: any) => {
    e.preventDefault();
    const { value } = e.target;
    setValues((prevState: any) => ({ ...prevState, [selectedValue]: value }));
  }
  useEffect(()=>{
    setSelectedValue("")
    if(component?.properties?.type==='number'){
      setLabelOptionsList([...labelOptionsList, { label: 'min', value: 'min', validType: "Number" },
      { label: 'max', value: 'max', validType: "Number" }])
    }else {
      setLabelOptionsList(validationTypeList)
    }
  },[component?.properties?.type])
  const handleAdd = () => {
    const sValue=selectedValue;
    setValues((prevState: any) => ({ ...prevState, [sValue]: "" }));
    dispatch(updateElement({
      id: selectedElementId,
      path: `properties.validation.${selectedValue}`,
      value: values[selectedValue]
    }))
    setSelectedValue("")
  }

  const onChange = (data: any, key: string) => {
    dispatch(updateElement({
      id: selectedElementId,
      path: key,
      value: data
    }))
  };

  if (!component?.id) {
    return null;
  }

  if (!component?.properties.validation) {
    return (<div>
      No data found
    </div>)
  }
 const showValidation=  labelOptionsList
 ? labelOptionsList.map((el) => ({
   name: el.label,
 })).filter((el) => !selectedList.includes(el.name))
 : [];

 const inputStyles = {
  marginLeft: "-6px",
  marginRight: "8px",
  cursor: !props.isCheckedIn ? "not-allowed" : "auto",
};
  const validationinput = {
    cursor: !props.isCheckedIn ? "not-allowed" : "auto",
    height: "28px",
    fontSize: "12px",
    borderBottom: "1px #7D8492 solid"
  };
    
  const validationButtonstyle = {
    background: "#052f35 ",
    cursor: !props.isCheckedIn ? "not-allowed" : "auto",
    height: "28px",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    fontSize: "12px",
  }

  return (
    <>
      { showValidation.length >0 && <div>
        <Panel isCheckedIn={props.isCheckedIn} section="validation" />
        {!ExcludedComponentTypes.includes(component?.type?.toLowerCase()) && <div className="panel-div">
          <label
            htmlFor="horizontal"
            className="block mt-2 py-1 px-2 text[11px] font-semibold text-gray-900 dark:text-gray-300"
          >
            Validation
          </label>
          <div style={inputStyles}>
          <Dropdown
          cursorStyle={!props.isCheckedIn ? "not-allowed" : "auto"}
          defaultValue={"Select"}
            disabled={!props.isCheckedIn}
            options={
              labelOptionsList
                ? labelOptionsList.map((el) => ({
                  name: el.label,
                })).filter((el) => !selectedList.includes(el.name))
                : []
            }
            selected={{ name: selectedValue }}
            onChange={(option) => {
              if (labelOptionsList) {
                const item = labelOptionsList.find(item => item.label === option.name)
                if (item) {
                  setSelectedValue(item.value)
                }
              }
            }}
          />
          </div>
        </div>}
        {selectedValue && <div className="grid grid-cols-3 gap-4 mx-2 mt-3">
         <input
            style={validationinput}
            disabled={!props.isCheckedIn}
            type="number || text"
            className="col-span-2 border-t-0 border-l-0 border-r-0 border-b-2 bg-white border-gray-300 text-gray-900 text-lg w-full p-2.5 focus:outline-none"
            placeholder="Enter value"
            value={values[selectedValue]}
            onChange={handleChange}
          />
          <button
            disabled={!props.isCheckedIn}
            style={validationButtonstyle}
            className="block py-2 px-2 text-lg font-semibold text-white dark:text-gray-300 rounded-lg"
            onClick={handleAdd}
          >
            Add
          </button>
        </div>}
        <hr className="my-4" style={{ borderTop: "2px dashed #F5F5F5" }} />
      </div>}
      {component?.properties?.validation &&
        Object.keys(component.properties.validation)
          .filter((property) => validationPropertyList.includes(property))
          .map((option, index) => (
            <ListValidationValue
              canEdit={true}
              key={index}
              option={option}
              options={component && component.properties && component.properties.validation}
              updateOptions={onChange}
            />
          ))
      }
    </>
  );
};
